'use strict';

let moment = require('moment');

exports.holidays = {
	'2017-01-01': true,
	'2017-01-16': true,
	'2017-02-20': true,
	'2017-05-29': true,
	'2017-07-04': true,
	'2017-09-04': true,
	'2017-10-09': true,
	'2017-11-10': true,
	'2017-11-23': true,
	'2017-12-25': true,
	'2018-01-01': true,
	'2018-01-15': true,
	'2018-02-19': true,
	'2018-05-28': true,
	'2018-07-04': true,
	'2018-09-03': true,
	'2018-10-08': true,
	'2018-11-12': true,
	'2018-11-22': true,  
	'2018-11-23': true, // Extra thanksgiving day off
	'2018-12-05': true, // GH Bush National Holiday
	'2018-12-25': true,
	'2019-01-01': true,
	'2019-01-21': true,
	'2019-02-18': true,
	'2019-05-27': true,
	'2019-07-04': true,
	'2019-09-02': true,
	'2019-10-14': true,
	'2019-11-11': true,
	'2019-11-28': true,
	'2019-12-25': true,
	'2020-01-01': true,
	'2020-01-20': true,
	'2020-02-17': true,
	'2020-05-25': true,
	'2020-07-03': true,
	'2020-09-07': true,
	'2020-10-12': true,
	'2020-11-11': true,
	'2020-11-26': true,
	'2020-12-25': true,
	'2021-01-01': true,
	'2021-01-18': true,
	'2021-02-15': true,
	'2021-05-31': true,
	'2021-07-05': true,
	'2021-09-06': true,
	'2021-10-11': true,
	'2021-11-11': true,
	'2021-11-25': true,
	'2021-12-24': true,
	'2022-01-01': true,
	'2022-01-17': true,
	'2022-02-21': true,
	'2022-04-15': true,
	'2022-05-30': true,
	'2022-06-20': true,
	'2022-07-04': true,
	'2022-09-05': true,
	'2022-10-10': true,
	'2022-11-11': true,
	'2022-11-24': true,
	'2022-12-26': true,
	'2023-01-02': true,
	'2023-01-16': true,
	'2023-02-20': true,
	'2023-05-29': true,
	'2023-06-19': true,
	'2023-07-04': true,
	'2023-09-04': true,
	'2023-10-09': true,
	'2023-11-10': true,
	'2023-11-23': true,
	'2023-12-25': true,
	'2024-01-01': true,
	'2024-01-15': true,
	'2024-02-19': true,
	'2024-05-27': true,
	'2024-06-19': true,
	'2024-07-04': true,
	'2024-09-02': true,
	'2024-10-14': true,
	'2024-11-11': true,
	'2024-11-28': true,
	'2024-12-25': true,
	'2025-01-01': true,
	'2025-01-20': true,
	'2025-02-17': true,
	'2025-05-26': true,
	'2025-06-19': true,
	'2025-07-04': true,
	'2025-09-01': true,
	'2025-10-13': true,
	'2025-11-11': true,
	'2025-11-27': true,
	'2025-12-25': true,
	'2026-01-01': true,
	'2026-01-19': true,
	'2026-02-16': true,
	'2026-05-25': true,
	'2026-06-19': true,
	'2026-07-03': true,
	'2026-09-07': true,
	'2026-10-12': true,
	'2026-11-11': true,
	'2026-11-26': true,
	'2026-12-25': true,
	'2027-01-01': true,
	'2027-01-18': true,
	'2027-02-15': true,
	'2027-05-31': true,
	'2027-06-18': true,
	'2027-07-05': true,
	'2027-09-06': true,
	'2027-10-11': true,
	'2027-11-11': true,
	'2027-11-25': true,
	'2027-12-24': true,
	

};

exports.maxDate = moment('2027-12-31');
exports.minDate = moment('2012-01-01');